import React, { useState } from "react";
import { Close } from "../../assets/image";

export const CreateCategory = ({ onClose, onSave }) => {
  const [formData, setFormData] = useState({
    title: "",
    type: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.title.trim()) newErrors.title = "Title is required";
    if (!formData.type) newErrors.type = "Category type is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) return;

    const data = {
      tittle: formData.title,
      categoryType: formData.type,
    };

    onSave(data);
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-4">
      <div className="bg-white w-full max-w-md rounded-xl shadow-lg relative">
        <div className="p-4">
          <div className="flex justify-between mb-3">
            <h2 className="text-xl text-primary font-semibold mb-2">Add New Category</h2>
            <button onClick={onClose} className="p-1.5 rounded-full">
              <img src={Close} alt="" className="w-5 h-5" />
            </button>
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium mb-1">Title</label>
            <input
              type="text"
              name="title"
              value={formData.title}
              onChange={handleChange}
              placeholder="Enter title"
              className="w-full border px-3 py-2 rounded-md text-sm"
            />
            {errors.title && <p className="text-red-500 text-sm mt-1">{errors.title}</p>}
          </div>

          <div className="mb-6">
            <label className="block text-sm font-medium mb-1">Category Type</label>
            <select
              name="type"
              value={formData.type}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded-md text-sm"
            >
              <option value="">Select type</option>
              <option value="blog">Blog</option>
              <option value="story">Story</option>
            </select>
            {errors.type && <p className="text-red-500 text-sm mt-1">{errors.type}</p>}
          </div>

          <div className="flex justify-end gap-3">
            <button onClick={onClose} className="px-4 py-2 text-sm border rounded-md hover:bg-gray-100">
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 text-sm bg-primary text-white rounded-md hover:bg-[#00008b]"
            >
              Add Category
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
